import './QuizQuestion.css';
import { useState, useEffect } from 'react';

function TimelineQuestion({ question, order, onOrderChange }) {
    // Initialize order if not set
    const [currentOrder, setCurrentOrder] = useState([]);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);

    useEffect(() => {
        if (!order || order.length === 0) {
            // Initialize with shuffled items
            const shuffled = [...question.items]
                .map(item => item.id)
                .sort(() => Math.random() - 0.5);
            setCurrentOrder(shuffled);
            onOrderChange(shuffled);
        } else {
            // Ensure we only use items that exist in the current question
            const validOrder = order.filter(itemId =>
                question.items.some(item => item.id === itemId)
            );

            // If the order doesn't contain all items from the question, reinitialize
            if (validOrder.length !== question.items.length) {
                const shuffled = [...question.items]
                    .map(item => item.id)
                    .sort(() => Math.random() - 0.5);
                setCurrentOrder(shuffled);
                onOrderChange(shuffled);
            } else {
                setCurrentOrder(validOrder);
            }
        }
    }, [question.id, question.items, order, onOrderChange]);

    const handleDragStart = (e, index) => {
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', e.currentTarget);
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';

        if (draggedIndex !== index) {
            setDragOverIndex(index);
        }
    };

    const handleDragLeave = () => {
        setDragOverIndex(null);
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();

        if (draggedIndex === null || draggedIndex === dropIndex) {
            setDragOverIndex(null);
            return;
        }

        const newOrder = [...currentOrder];
        const draggedItem = newOrder[draggedIndex];

        // Remove from old position
        newOrder.splice(draggedIndex, 1);
        // Insert at new position
        newOrder.splice(dropIndex, 0, draggedItem);

        setCurrentOrder(newOrder);
        onOrderChange(newOrder);
        setDraggedIndex(null);
        setDragOverIndex(null);
    };

    const handleDragEnd = () => {
        setDraggedIndex(null);
        setDragOverIndex(null);
    };

    const getItemById = (id) => {
        return question.items.find(item => item.id === id);
    };

    return (
        <div className="timeline-question">
            <h2 className="question-text">{question.questionText}</h2>

            <div className="timeline-instruction">
                Přetáhněte položky na správné místo pro uspořádání.
            </div>

            <div className="timeline-container">
                {currentOrder.map((itemId, index) => {
                    const item = getItemById(itemId);
                    if (!item) return null;

                    const isDragging = draggedIndex === index;
                    const isDragOver = dragOverIndex === index;

                    return (
                        <div
                            key={item.id}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => handleDragOver(e, index)}
                            onDragLeave={handleDragLeave}
                            onDrop={(e) => handleDrop(e, index)}
                            onDragEnd={handleDragEnd}
                            className={`timeline-item ${isDragging ? 'dragging' : ''} ${isDragOver ? 'drag-over' : ''}`}
                        >
                            <div className="timeline-number">{index + 1}</div>
                            <div className="timeline-item-text">{item.text}</div>
                            <div className="drag-handle">⋮⋮</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default TimelineQuestion;
